import React, { useContext, useEffect, useState } from "react";
import { MemoContext } from "../../contexts/MemoContext";
import EmptyMemo from "../../components/EmptyMemo";
import { useParams, useHistory } from "react-router-dom";
import MemoItem from "../../components/MemoItem";
import Masonry from "react-masonry-css";
import axios from "axios";
import { CatTagContext } from "../../contexts/CatTagContext";

const TagIndex = () => {
  const { memoData } = useContext(MemoContext);
  const { tags } = useContext(CatTagContext);
  const { tid } = useParams();
  const [tMid, setTMid] = useState([]);
  const history = useHistory();
  const [tag, setTag] = useState("Loading..");
  useEffect(() => {
    axios
      .get(`/tag/${tid}`)
      .then((sRes) => {
        setTMid(sRes.data.map((e) => e.mid));
      })
      .catch((e1) => {
        console.log(e1);
      });
  }, [tid]);
  useEffect(() => {
    if (tags.length > 0) {
      let tagName = tags.filter((e) => e.tid === parseInt(tid));
      setTag(tagName[0].tag);
      console.log(tags);
    }
  }, [tid, tags]);
  useEffect(() => {}, [tMid]);
  return (
    <div className="w-full h-full overflow-scroll p-5">
      <div className="flex w-full justify-between px-1 items-center mb-4">
        <div className="text-xl text-gray-500 flex items-center">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            />
          </svg>
          <p className="p-0 m-0 ml-3">{tag}</p>
        </div>
        <div
          className="text-xl text-gray-500 flex items-center cursor-pointer"
          onClick={() => history.push("/")}
        >
          <svg
            className="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
          <p className="p-0 m-0 ml-3">Back</p>
        </div>
      </div>
      {tMid.length > 0 ? (
        <Masonry
          breakpointCols={4}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {memoData
            .filter((e) => {
              return tMid.indexOf(e.mid) > -1;
            })
            .map((e) => {
              return (
                <MemoItem
                  key={e.mid}
                  mid={e.mid}
                  content={e.memo_content}
                  tags={e.tags}
                  created={e.created}
                  fav={e.fav}
                  updated={e.updated}
                />
              );
            })}
        </Masonry>
      ) : (
        <div className="w-full h-full flex flex-col justify-center items-center">
          <EmptyMemo />
        </div>
      )}
    </div>
  );
};

export default TagIndex;
